module.exports = __webpack_public_path__ + "static/img/ninja-can-29.c84c72b2.png";